import { render, staticRenderFns } from "./TalentSearch.vue?vue&type=template&id=3ea16f8a&lang=pug&"
import script from "./TalentSearch.vue?vue&type=script&lang=js&"
export * from "./TalentSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports